import React, { useContext, useState, useEffect } from 'react'
import './FirstPage.css'
// import UserContext from '../../Context/UserContext';
import TermsConditions from '../../Components/TermsConditions';
import { useAuth0 } from '@auth0/auth0-react';
import { Button } from 'antd';


const FirstPage = () => {
    // const isAuthenticated = useIsAuthenticated()
    // const { instance } = useMsal()

    // const {  setUser } = useContext(UserContext)
    const [checkControl, setCheckControl] = useState(false)

    const handleChangeCheck = () => {

        setCheckControl(!checkControl)

        if (checkControl === false) {
            console.log("true")
        }
        if (checkControl === true) {
            console.log("false")
        }

    }

    // const handleSignIn = () => {
    //     instance.loginRedirect({
    //         scopes: ['user.read']
    //     })
    // }

    //* direk azure sayfasına yönlendirmek istesek;
    // useEffect(() => {
    //     if (!isAuthenticated) {
    //         instance.ssoSilent({
    //             scopes: ["user.read"],
    //             loginHint: ""
    //         }).then((response) => {
    //             console.log(response)
    //             instance.setActiveAccount(response.account);
    //         }).catch((error) => {
    //             if (error instanceof InteractionRequiredAuthError) {
    //                 instance.loginRedirect({
    //                     scopes: ["user.read"],
    //                 })
    //             }
    //         })
    //     }
    // }, [])


    // useEffect(() => {
    //     setUser({ isLogin: isAuthenticated, accountDetail: instance.getActiveAccount() });
    // }, [isAuthenticated, instance])

    // console.log("home active account", instance.getActiveAccount());

    // console.log(checkControl)
    const { loginWithRedirect, isAuthenticated  } = useAuth0();
    // useEffect(() => {
    //     // Sayfa yüklendiğinde loginWithRedirect() otomatik olarak çalışsın
    //     loginWithRedirect();
    // }, []);
   
    return (
        <div>
            <div className='homePage' >
                <div className='terms-box'>
                    <div >
                        <div className='terms-text'>
                            <TermsConditions />
                        </div>
                        <div>
                            <label style={{fontSize: "13px"}}>
                            <input
                            style={{marginRight: "4px"}}
                                type="checkbox"
                                value={checkControl}
                                onClick={handleChangeCheck}
                            />
                             Okudum,anladım. Kabul ediyorum.
                            </label>
                        </div>
                        <div className='signInButton'>
                            <Button disabled={checkControl === false} className="signInOn" 
                            // onClick={handleSignIn}
                            onClick={() => loginWithRedirect()}
                            >Sign In</Button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default FirstPage
